(function () {
  var EVENT_NAME = 'fabini_engagement_checkpoint';
  var MIN_DELTA_MS = 100;
  var visibleStartedAt = document.visibilityState === 'hidden' ? null : now();
  var accumulatedVisibleMs = 0;
  var publishedVisibleMs = 0;

  function now() {
    if (window.performance && typeof window.performance.now === 'function') {
      return window.performance.now();
    }

    return Date.now();
  }

  function getVisibleMs() {
    if (visibleStartedAt === null) return accumulatedVisibleMs;

    return accumulatedVisibleMs + Math.max(0, now() - visibleStartedAt);
  }

  function getPagePath() {
    return window.location.pathname + window.location.search;
  }

  function getAnalytics() {
    return (
      window.Shopify &&
      window.Shopify.analytics &&
      typeof window.Shopify.analytics.publish === 'function' &&
      window.Shopify.analytics
    );
  }

  function publishCheckpoint(exitReason) {
    var analytics = getAnalytics();
    if (!analytics) return;

    var visibleMs = getVisibleMs();
    var deltaMs = Math.round(visibleMs - publishedVisibleMs);
    if (deltaMs < MIN_DELTA_MS) return;

    publishedVisibleMs += deltaMs;

    analytics.publish(EVENT_NAME, {
      engagement_time_msec: deltaMs,
      page_path: getPagePath(),
      exit_reason: exitReason,
    });
  }

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') {
      accumulatedVisibleMs = getVisibleMs();
      visibleStartedAt = null;
      publishCheckpoint('visibility_hidden');
      return;
    }

    visibleStartedAt = now();
  });

  window.addEventListener('pagehide', function () {
    publishCheckpoint('pagehide');
  });

  document.addEventListener(
    'click',
    function (event) {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
        return;
      }

      var link = event.target && event.target.closest && event.target.closest('a[href]');
      if (!link || link.target === '_blank' || link.hasAttribute('download')) return;

      var url;
      try {
        url = new URL(link.href, window.location.href);
      } catch (error) {
        return;
      }

      if (url.origin !== window.location.origin || url.href === window.location.href) return;

      publishCheckpoint('internal_link_click');
    },
    true
  );
})();
